import Button from 'shared/ui/Button';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTask, getFields } from 'store/Jobs/actions';
import { selectJobModel } from 'store/Jobs/selectors';
import TaskList from './components/TaskList';
import {
  Wrapper, Title, Description, Buttons
} from './styled';
import EntitySelector from './components/EntitySelector';

const Tasks = () => {
  const dispatch = useDispatch();
  const model = useSelector(selectJobModel);

  useEffect(() => {
    dispatch(getFields());
  }, [dispatch]);

  const handleAddTask = () => dispatch(addTask());
  return model && (
    <Wrapper>
      <Title>Tasks</Title>
      <Description>Configure tasks to process the evaluated data</Description>
      { model === 'vulnerability' && <EntitySelector /> }
      <TaskList />
      <Buttons>
        <Button variant="link" onClick={ handleAddTask }>+ Add Task</Button>
      </Buttons>
    </Wrapper>
  );
};
export default Tasks;
